module.exports = __webpack_public_path__ + "static/media/orange_cost.afc63379.svg";